import { modes } from '@constants/orderWizard'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { predefinedWindowOptions } from './UnmonitoredDeliveryWindow'

export const useUnmonitoredWindow = (wizardOrder, setPayload, setMode) => {
  const [isSettingCustom, setIsSettingCustom] = useState()
  const [selectedTimeWindow, setSelectedTimeWindow] = useState(predefinedWindowOptions[0].value)
  const [selectedDate, setSelectedDate] = useState()
  const [customDeliveryDate, setCustomDeliveryDate] = useState()

  useEffect(() => {
    if (wizardOrder.dispatch_window_start || wizardOrder.delivery_window_start) {
      initializeWithWindow()
    } else {
      initializeNewWindow()
    }
    setMode(modes.EDIT)
  }, [])

  useEffect(() => {
    if (!customDeliveryDate) return
    if (!isSettingCustom) {
      const parsedTimeWindow = JSON.parse(selectedTimeWindow)
      const [startHour, endHour] = parsedTimeWindow
      const diff = endHour === 0 ? 24 - startHour : Math.abs(endHour - startHour)
      const newStart = moment(selectedDate).hours(startHour).minutes(0).seconds(0)
      const newEnd = moment(selectedDate).hours(startHour).minutes(0).seconds(0).add(diff, 'hours')
      setCustomDeliveryDate([newStart, newEnd])
      updatePayload(newStart, newEnd)
    }
  }, [selectedDate, selectedTimeWindow, isSettingCustom])

  const handleTimeChange = (dates) => {
    setCustomDeliveryDate(dates)
    setSelectedDate(dates[0])
    updatePayload(dates[0], dates[1])
  }

  // //////////////////////////////////////
  const updatePayload = (windowStart, windowEnd) => {
    setPayload((payload) => ({
      ...payload,
      dispatch_window_override_start: moment(windowStart).toISOString(),
      dispatch_window_override_end: moment(windowEnd).toISOString(),
    }))
  }
  const initializeNewWindow = () => {
    const startOfTomorrow = moment().startOf('day').add(1, 'day')
    const newStart = moment(startOfTomorrow)
    const newEnd = moment(startOfTomorrow).add(6, 'hours')
    setSelectedTimeWindow(predefinedWindowOptions[0].value)
    setIsSettingCustom(false)
    setSelectedDate(startOfTomorrow)
    setCustomDeliveryDate([newStart, newEnd])
    updatePayload(newStart, newEnd)
  }

  const initializeWithWindow = () => {
    const start = wizardOrder.dispatch_window_start || wizardOrder.delivery_window_start
    const end = wizardOrder.dispatch_window_end || wizardOrder.delivery_window_end
    const windowStart = moment(start)
    const windowEnd = moment(end)
    const startHour = windowStart.get('hours')
    const endHour = windowEnd.get('hours')

    const isPredefinedWindow = predefinedWindowOptions.some(
      (option) => option.startHour === startHour && option.endHour === endHour
    )

    setIsSettingCustom(!isPredefinedWindow)
    setSelectedTimeWindow(JSON.stringify([startHour, endHour]))
    setSelectedDate(moment(start))
    setCustomDeliveryDate([windowStart, windowEnd])
    updatePayload(start, end)
  }
  return {
    isSettingCustom,
    selectedDate,
    setSelectedDate,
    selectedTimeWindow,
    setSelectedTimeWindow,
    setIsSettingCustom,
    customDeliveryDate,
    handleTimeChange,
  }
}
